import styled from "styled-components";
import {SearchBoxMobileIconDefaultBox} from "./search-box-mobile-icon.default.box";

export const SearchBoxMobileIconCasino777Box= styled(SearchBoxMobileIconDefaultBox)`
        left: 2rem;
        background-position: -488px -581px;
`;
